import '../scss/style.scss'

import './jquery'

var __svg__ = {
  path: '../icons/**/*.svg',
  name: 'icons.svg',
}



// WEBPACK FOOTER //
// ./js/index-with-styles.js